import { useUserActions } from "_actions";
import { Button, Checkbox, Form, Input, message } from "antd";
import { Lock, Mail } from "lucide-react";
import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";

export const LoginPage = () => {
  const [form] = Form.useForm();
  const [isLoading, setIsLoading] = useState(false);
  const userActions = useUserActions();
  const navigate = useNavigate();

  const onFinish = (values: { username: string; password: string }) => {
    setIsLoading(true);
    userActions
      .login(values)
      .then(
        (_res) => {
          navigate("/");
        },
        (error) => {
          console.error(error.response.data.message);
          message.error(error.response.data.message);
        }
      )
      .finally(() => {
        setIsLoading(false);
      });
  };

  return (
    <main
      className="h-screen space-y-4 flex items-center -mt-10 py-8 px-2"
      style={{
        backgroundImage: "url('" + process.env.PUBLIC_URL + "/bg.png')",
      }}
    >
      <section className="flex flex-col max-w-md justify-center relative container bg-white rounded-lg lg:shadow-lg mx-auto px-8 py-12 lg:px-2 z-10">
        <div className="sm:mx-auto sm:w-full sm:max-w-sm">
          <img
            className="mx-auto h-24 w-auto"
            src={process.env.PUBLIC_URL + "/logo.svg"}
            alt="Capricorne Mindframe"
          />
          <h1 className="text-center text-3xl font-semibold tracking-tight text-gray-900 mt-4 py-4">
            Sign in
          </h1>
          <p className="text-center text-gray-500">
            Welcome back to Capricorne Mindframe
          </p>
        </div>

        <div className="mt-10 sm:mx-auto sm:w-full sm:max-w-sm">
          <Form
            form={form}
            autoComplete="off"
            layout="vertical"
            requiredMark="optional"
            validateTrigger="onSubmit"
            initialValues={{ remember: true }}
            onFinish={onFinish}
          >
            <Form.Item
              name={"username"}
              rules={[
                {
                  required: true,
                  message: "Please input your email!",
                  type: "email",
                },
              ]}
            >
              <Input
                className="rounded-lg border-0 py-1.5 px-3 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm/6"
                prefix={<Mail className="h-4" />}
                placeholder="Email"
              />
            </Form.Item>
            <Form.Item
              name={"password"}
              rules={[
                {
                  required: true,
                  message: "Please input your password!",
                  type: "string",
                },
                {
                  min: 6,
                  message: "Password must be at least 6 characters long",
                },
                {
                  max: 20,
                  message: "Password must be at most 20 characters long",
                },
              ]}
            >
              <Input.Password
                className="rounded-lg border-0 py-1.5 px-3 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm/6"
                prefix={<Lock className="h-4" />}
                placeholder="Password"
              />
            </Form.Item>
            <Form.Item>
              <Form.Item name="remember" valuePropName="checked" noStyle>
                <Checkbox>Remember me</Checkbox>
              </Form.Item>
              <Link
                to="/auth/forgot-password"
                className="float-end font-medium text-primary hover:text-blue-500"
              >
                Forgot password?
              </Link>
            </Form.Item>

            <Button
              htmlType="submit"
              loading={isLoading}
              className="flex w-full justify-center rounded-lg bg-primary p-4 text-sm/6 font-semibold text-white shadow-sm hover:bg-blue-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary"
            >
              {isLoading ? "Verifying Credentials" : "Sign in"}
            </Button>
          </Form>

          <p className="mt-10 text-center text-sm/6 text-gray-500">
            Not a member?
            <Link
              to="/auth/register"
              className="font-medium text-primary hover:text-blue-500 ms-2"
            >
              Register Now
            </Link>
          </p>
        </div>
      </section>
    </main>
  );
};
